import { Alert, Button, Typography } from 'antd';
import { ThunderboltOutlined } from '@ant-design/icons';
import { useSimulation } from '../../context/SimulationContext';
import './MutationOverlay.scss';

function MutationOverlay() {
  const { mutationEvent, showMutationOverlay, dispatch } = useSimulation();

  if (!showMutationOverlay || !mutationEvent) return null;

  return (
    <div className="mutation-overlay">
      <div className="mutation-overlay-content">
        <Alert
          type="warning"
          showIcon
          icon={<ThunderboltOutlined />}
          message="Unexpected Event"
          description={mutationEvent.description}
        />
        {mutationEvent.injectedArtifacts &&
          mutationEvent.injectedArtifacts.length > 0 && (
            <Typography.Text>
              New information has been added to your workspace.
            </Typography.Text>
          )}
        <Button
          type="primary"
          size="large"
          onClick={() => dispatch({ type: 'DISMISS_MUTATION_OVERLAY' })}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

export default MutationOverlay;
